import { toArray } from '@antv/util';
import { SHAPE_TO_TAGS } from '../constant';
/**
 * åå»ºå¹¶è¿åå¾å½¢ç svg åç´ 
 * @param type svgç±»å
 */
export function createSVGElement(type) {
    return document.createElementNS('http://www.w3.org/2000/svg', type);
}
/**
 * åå»ºå¹¶è¿åå¾å½¢ç dom åç´ 
 * @param  {IShape} shape å¾å½¢
 * @return {SVGElement}
 */
export function createDom(shape) {
    var type = SHAPE_TO_TAGS[shape.type];
    var parent = shape.getParent();
    if (!type) {
        throw new Error("the type " + shape.type + " is not supported by svg");
    }
    var element = createSVGElement(type);
    if (shape.get('id')) {
        element.id = shape.get('id');
    }
    shape.set('el', element);
    shape.set('attrs', {});
    // å¯¹äº defs ä¸ç dom èç¹ï¼parent ä¸ºç©ºï¼éè¿ context ç»ä¸æè½½å° defs èç¹ä¸
    if (parent) {
        var parentNode = parent.get('el');
        if (parentNode) {
            parentNode.appendChild(element);
        }
        else {
            // parentNode maybe null for group
            parentNode = parent.createDom();
            parent.set('el', parentNode);
            parentNode.appendChild(element);
        }
    }
    return element;
}
/**
 * å¯¹ dom åç´ è¿è¡æåº
 * @param {IElement} element  åç´ 
 * @param {sorter}   function æåºå½æ°
 */
export function sortDom(element, sorter) {
    var el = element.get('el');
    var childList = toArray(el.children).sort(sorter);
    // create empty fragment
    var fragment = document.createDocumentFragment();
    childList.forEach(function (child) {
        fragment.appendChild(child);
    });
    el.appendChild(fragment);
}
/**
 * å° dom åç´ ç§»å¨å°ç¶åç´ ä¸çæå®ä½ç½®
 * @param {SVGElement} element     dom åç´ 
 * @param {number}     targetIndex ç®æ ä½ç½®(ä» 0 å¼å§)
 */
export function moveTo(element, targetIndex) {
    var parentNode = element.parentNode;
    var siblings = Array.from(parentNode.childNodes).filter(
    // è¦æ±ä¸ºåç´ èç¹ï¼ä¸ä¸è½ä¸º defs èç¹
    function (node) { return node.nodeType === 1 && node.nodeName.toLowerCase() !== 'defs'; });
    // è·åç®æ èç¹
    var target = siblings[targetIndex];
    var currentIndex = siblings.indexOf(element);
    // å¦æç®æ èç¹å­å¨
    if (target) {
        // å½åç´¢å¼ > ç®æ ç´¢å¼ï¼ç´æ¥æå¥å°ç®æ èç¹ä¹åå³å¯
        if (currentIndex > targetIndex) {
            parentNode.insertBefore(element, target);
        }
        else if (currentIndex < targetIndex) {
            // å½åç´¢å¼ < ç®æ ç´¢å¼
            // è·åç®æ èç¹çä¸ä¸ä¸ªèç¹
            var targetNext = siblings[targetIndex + 1];
            // å¦æç®æ èç¹çä¸ä¸ä¸ªèç¹å­å¨ï¼æå¥å°è¯¥èç¹ä¹å
            if (targetNext) {
                parentNode.insertBefore(element, targetNext);
            }
            else {
                // å¦æè¯¥èç¹ä¸å­å¨ï¼åè¿½å å°æ«å°¾
                parentNode.appendChild(element);
            }
        }
    }
    else {
        parentNode.appendChild(element);
    }
}
//# sourceMappingURL=dom.js.map